module.exports = __webpack_public_path__ + "static/img/logo.8dcc849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news25/logo.jpg
// module id = Loig
// module chunks = 1